// Lodash にも _.toString(value) があるが、Lodash を使わない決定をした場合などのために作っておく。
/** String() では null や undefined を渡すと、'null' や 'undefined' となってしまうので、それらの場合 '' を返す関数。 */
export const toString = (value: unknown) => (typeof value === 'undefined' || value === null ? '' : String(value));
